import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UserOwnerRel} from '../model/userOwnerRel';
import {UserService} from '../service/user.service';
import {Log} from '../util/log';
import {Router} from '@angular/router';

@Component({
  selector: 'app-device-users-list-dialog',
  templateUrl: './device-users-list-dialog.component.html',
  styleUrls: ['./device-users-list-dialog.component.css']
})
export class DeviceUsersListDialogComponent implements OnInit {

  @ViewChild('userslisttable', {static: true}) table;
  @ViewChild('userslistloader', {static: true}) loader;
  @ViewChild(MatSort) sort: MatSort;

  usersUpdateStatus: string = '';

  usersList: UserOwnerRel[];
  selectedUsers: UserOwnerRel[];

  groupNames = new Map();

  // noGroupString = $localize`:@@userslist_no_group:Nessuno`
  noGroupString = 'Nessuno';

  deviceSerial: string;
  ownerUid: string;

  displayedColumns: string[] = [
    'checkbox',
    'name',
    'description',
    'groupName',
    'user',
    'modifyUser'
  ];

  constructor(
    public dialogRef: MatDialogRef<DeviceUsersListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
  ) {

    this.deviceSerial = data.deviceSerial;
    this.ownerUid = data.ownerUid;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.selectedUsers = [];
    this.getGroups();
  }

  manageUsers() {
    this.loader.showLoading();

    this.userService.getDeviceUsers(this.deviceSerial, this.ownerUid).subscribe(usersList => {
      this.usersList = usersList;

      Log.debug('\n\n\nthis.usersList');
      Log.debug(this.usersList);

      for (let i = 0; i < this.usersList.length; i++) {
        Log.debug(this.getGroupNameById(this.usersList[i].groupId));
        this.usersList[i].groupName = this.getGroupNameById(this.usersList[i].groupId);
      }

      this.table.dataSource = new MatTableDataSource(this.usersList);
      this.table.dataSource.filterPredicate = this.filterTable;
      this.table.dataSource.sort = this.sort;

      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);
    }, err => {
      this.loader.showError();
    });
  }

  getGroups() {
    const obs = this.userService.getOwnerGroups(this.ownerUid);
    obs.subscribe(data => {
      for (let i = 0; i < data.length; i++) {
        this.groupNames.set(data[i].groupId, data[i].name);
      }

      Log.debug('\n\n\n this.groupNames');
      Log.debug(this.groupNames);

      this.manageUsers();

    }, error => {
      this.loader.hideLoading();
      this.loader.showError();
    });
    // this.loader.hideLoading();
  }


  getGroupNameById(Id: number) {
    if (Id == 0) {
      return this.noGroupString;
    } else {
      return this.groupNames.get(Id);
    }
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  isUserSelected(user: UserOwnerRel) {
    // let result =
    if (this.selectedUsers.indexOf(user) >= 0) {
      return true
    } else {
      return false;
    }
  }

  addSelectedUser(user: UserOwnerRel) {
    Log.debug('\n\nthis.selectedUsers before');
    Log.debug(this.selectedUsers);
    let result = this.selectedUsers.indexOf(user)
    if (result >= 0) {
      this.selectedUsers.splice(result, 1);
    } else {
      this.selectedUsers.push(user);
    }
    Log.debug('\nthis.selectedUsers after');
    Log.debug(this.selectedUsers);
  }

  onRowClicked(row) {

    this.dialogRef.close();

    Log.debug('clicked user with id ' + row.id);

    // this.selectedRow = row.id;

    // this.selected.emit(row.user);
    // this.selectedUser = row;

    //TO CHECK: previsto un emit utente, usato routing
    this.router.navigate(['add-user/' + row.id]);

    this.cdRef.detectChanges();
  }

  onKey(event: any) {

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: UserOwnerRel, filter: string): boolean {

    if (data.user && data.user.displayName && data.user.displayName.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.user && data.user.email && data.user.email.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.groupName && data.groupName.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  resaveUsers() {
    Log.debug('resaveUsers clicked');
    this.resaveUser(0);
  }

  resaveUser(index) {

    this.usersUpdateStatus = 'updating user ' + index + ' out of ' + this.selectedUsers.length;

    Log.debug("\nin resaveUser with index: " + index + "\n");

    let user = this.selectedUsers[index];
    let userOwnerRelToPut: UserOwnerRel = new UserOwnerRel();
    userOwnerRelToPut.name = user.name;
    userOwnerRelToPut.description = user.description;
    userOwnerRelToPut.id = user.id;
    userOwnerRelToPut.groupId = user.groupId;

    this.userService.updateUserOwnerRelForce(userOwnerRelToPut, user.id).subscribe((response) => {
      setTimeout(() => {
        Log.debug("\nin setTimeout with index: " + index + "\n");

        if (index + 1 < this.selectedUsers.length) {
          this.resaveUser(index + 1);
        } else {
          this.usersUpdateStatus = 'updated all ' + this.selectedUsers.length + ' users';
        }
        // }, 30000); timeout safe che avevo usato per i resave di massa
      }, 20000);
    }, (err) => {
      Log.debug(err);
      Log.debug("updateUserOwnerRel error");
      this.loader.showError();
    });
  }

  checkAll() {
    this.selectedUsers = this.usersList;
  }

  uncheckAll() {
    this.selectedUsers = [];
  }

}
